import AdvantageIcon from './AdvantageIcon';

export default AdvantageIcon;
export { AdvantageIcon };
